import React from "react";
import { transformBrandNames } from "../../../../../../utils";
import { RenderWhen } from "../../../../../../components";
import { TiCardActor } from "../../../../@types";
import TiCardAdditionalInformationLayout, {
  TiCardAdditionalInformationLayoutProps
} from "./TiCardAdditionalInformationLayout";
import { countryCodes } from "../../consts";

interface Props extends TiCardAdditionalInformationLayoutProps {
  actorData: TiCardActor;
}

const TiCardActorAdditionalInformation = ({
  actorData,
  seeRelatedSamplesRoute,
  closeDetails
}: Props) => (
  <TiCardAdditionalInformationLayout
    closeDetails={closeDetails}
    seeRelatedSamplesRoute={seeRelatedSamplesRoute}
  >
    <p style={{ marginBottom: 0 }} data-testid="ticard_actor_description">
      <b>Actor Description: </b>

      {actorData.description
        ? transformBrandNames(actorData.description)
        : "No description found."}
    </p>
    <RenderWhen
      condition={
        actorData.country.length > 0 && !!countryCodes[actorData.country]
      }
    >
      <p style={{ marginBottom: 0 }} data-testid="ticard_actor_country">
        <b>Country: </b>
        <span className={`flag flag-${countryCodes[actorData.country]}`} />
        {actorData.country}
      </p>
    </RenderWhen>

    <RenderWhen condition={actorData.aliases.length > 0}>
      <p style={{ marginBottom: 0 }} data-testid="ticard_actor_aliases">
        <b>Aliases: </b>
        {actorData.aliases.join(", ")}
      </p>
    </RenderWhen>

    <div
      className={"ticard-content__additional_information__references"}
      data-testid="ticard_actor_references"
    >
      <b>References:</b>
      <div className={"references_list"}>
        <RenderWhen
          condition={!!actorData.references?.length}
          fallback={"No references found."}
        >
          {actorData.references?.map((reference, idx) => (
            <a
              key={`news_${reference}`}
              className={"overflow-ellipsis"}
              href={reference}
              target="_blank"
              rel="noreferrer"
              data-testid={`ticard_actor_references_link_item_${idx}`}
            >
              {reference}
            </a>
          ))}
        </RenderWhen>
      </div>
    </div>
  </TiCardAdditionalInformationLayout>
);

export default TiCardActorAdditionalInformation;
